import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {validateEmpty} from '../../../../global/custom-validate';
import {language} from '../../../../language/vn';
import {BsModalService} from 'ngx-bootstrap/modal';
import {DatePipe} from '@angular/common';
import {environment} from '../../../../../environments/environment';
import {LoaiVanBan} from '../../../../models/danhmuc/loaivanban';
import {LinhVucVanBan} from '../../../../models/danhmuc/linhvucvanban';
import {DoMat} from '../../../../models/danhmuc/domat';
import {DoKhan} from '../../../../models/danhmuc/dokhan';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {VanBanDenFileService} from '../../../../service/vanbanden/service-vanbandenfile';
import {LoaiVanBanService} from '../../../../service/danhmuc/service-loaivanban';
import {LinhVucVanBanService} from '../../../../service/danhmuc/service-linhvucvanban';
import {DoMatService} from '../../../../service/danhmuc/service-domat';
import {DoKhanService} from '../../../../service/danhmuc/service-dokhan';
import {GroupOTherComponent} from '../../groupother/groupother.component';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {SoVanThu} from '../../../../models/info/sovanthu';
import {SoVanThuService} from '../../../../service/info/service-sovanthu';
import {Router} from '@angular/router';

@Component({
  templateUrl: './create.component.html',

})
export class SoanVanBanDenComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public submitValidate = false;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public dataLoaiVanBan: LoaiVanBan[];
  public dataLinhVuc: LinhVucVanBan[];
  public dataDoMat: DoMat[];
  public dataDoKhan: DoKhan[];
  public dateNgayKy: Date= new Date();
  public dateNgayNhan: Date= new Date();
  public dateNgayVaoSo: Date= new Date();
  public defaultValue: string[]=["0"];
  public soVanThuItem: SoVanThu = new SoVanThu();
  @ViewChild("selectGroup")
  public selectGroup: GroupOTherComponent;
  constructor(
    public vanBanDenService: VanBanDenService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public vanBanDenFileService: VanBanDenFileService,
    public loaiVanBanService: LoaiVanBanService,
    public linhVucVanBanService: LinhVucVanBanService,
    public doMatService: DoMatService,
    public doKhanService: DoKhanService,
    public datepipe: DatePipe,
    public soVanThuService: SoVanThuService,
    public router: Router


  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      soVaoSo: new FormControl(),
      soHieuGoc: new FormControl(),
      maLoaiVB: new FormControl(),
      trichYeu: new FormControl(),
      maLinhVuc: new FormControl(),
      maDoMat: new FormControl(),
      maDoKhan: new FormControl(),
      ngayKy: new FormControl(),
      nguoiKy: new FormControl(),
      ngayNhan: new FormControl(),
      ngayVaoSo: new FormControl(),
      ghiChu: new FormControl(),
      maNguoiChuTri: new FormControl(),
      maNoiGui: new FormControl(),
      maTrangThaiXL: new FormControl(),
      soVanThuID: new FormControl(),
      nguoiNhapID: new FormControl()

    });
    this.frmGroup = this.formBuilder.group({
      id:  ['0', Validators.nullValidator],
      soVaoSo: ['' , Validators.compose([validateEmpty]) ],
      soHieuGoc: ['' , Validators.compose([validateEmpty]) ],
      maLoaiVB: ['' , Validators.compose([validateEmpty]) ],
      trichYeu: ['' , Validators.compose([validateEmpty]) ],
      maLinhVuc: ['' , Validators.nullValidator],
      maDoMat: ['' , Validators.nullValidator],
      maDoKhan: ['' , Validators.nullValidator],
      ngayKy: ['' , Validators.compose([validateEmpty]) ],
      nguoiKy: ['' , Validators.compose([validateEmpty]) ],
      ngayNhan: ['' , Validators.compose([validateEmpty]) ],
      ngayVaoSo: ['' , Validators.compose([validateEmpty]) ],
      ghiChu: ['', Validators.nullValidator],
      maNguoiChuTri:  ['0', Validators.nullValidator],
      soVanThuID:  ['0', Validators.nullValidator],
      maNoiGui:  ['0', Validators.nullValidator],
      maTrangThaiXL:  ['0', Validators.nullValidator],
      nguoiChuTriID:  ['0', Validators.nullValidator]
    });
    this.uploadUrl= this.vanBanDenFileService.urlUpload;
    this.deleteUrl= this.vanBanDenFileService.urlDelete;
    this.loaiVanBanService.getAll().subscribe(data => this.dataLoaiVanBan = data);
    this.linhVucVanBanService.getAll().subscribe(data => this.dataLinhVuc = data);
    this.doMatService.getAll().subscribe(data => this.dataDoMat = data);
    this.doKhanService.getAll().subscribe(data => this.dataDoKhan = data);
    this.soVanThuService.getByMaDonViId(Sessioncommand.maDonVi).subscribe(
      data =>
      {
        this.soVanThuItem= data;
        this.frmGroup.patchValue({soVaoSo : this.soVanThuItem.soVaoSo + 1});
      }
    );
  }
  get f() { return this.frmGroup.controls; }

  createItem ()
  {
    if( this.uploadFileComponent.uploadCommand.getFilesData().length > 0) {
      this.frmGroup.value.ngayKy = this.datepipe.transform(this.dateNgayKy, 'dd/MM/yyyy');      ;
      this.frmGroup.value.ngayNhan = this.datepipe.transform(this.dateNgayNhan, 'dd/MM/yyyy');      ;
      this.frmGroup.value.ngayVaoSo = this.datepipe.transform(this.dateNgayVaoSo, 'dd/MM/yyyy');
      this.frmGroup.value.maNguoiChuTri = 0;
      this.frmGroup.value.maNoiGui = Number(this.selectGroup.selectTree.value);
      this.frmGroup.value.nguoiNhapID = Sessioncommand.staffId;
      this.frmGroup.value.maTrangThaiXL = Number(environment.chogiaoxuly);
      this.frmGroup.value.soVanThuID = this.soVanThuItem.id;
      if(Number(this.selectGroup.selectTree.value)==0)
      {
        this.toastr.error(language.error_selectnoigui, language.message);
      }else {
        this.vanBanDenService.add(this.frmGroup.value).subscribe(
          {
            next: (data) => {
              this.uploadFileComponent.id = data.id;
              this.uploadFileComponent.uploadCommand.upload(this.uploadFileComponent.uploadCommand.getFilesData());
              this.toastr.success(language.add_success_record, language.message);
              Sessioncommand.notification = true;
              Sessioncommand.vanBanDenStatus = 0;
              this.router.navigate(['/vanbanden/qlvanbanden'], {  queryParams: {  ty: 'dvso' } });
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          });
      }
    }
    else
    {
      this.toastr.error(language.message_no_file_attach, language.message);
    }
  }

  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    this.createItem();
  }


}

